import classNames from 'classnames'
import styles from './Tile.module.css'
import { LayoutStack } from '../layouts'
import { TileCompanionProps, TileProps } from './types'

function Tile({ id, className, children, border = 'neutral' }: TileProps) {
  return (
    <LayoutStack
      id={id}
      space="none"
      className={classNames([
        styles.container,
        {
          [styles.neutralBorderContainer!]: border === 'neutral',
          [styles.transparentBorderContainer!]: border === 'transparent',
        },
        className ?? '',
      ])}
    >
      {children}
    </LayoutStack>
  )
}

function Header({ children, className, ...props }: TileCompanionProps) {
  return (
    <div className={classNames(className, styles.headerContainer)} {...props}>
      {children}
    </div>
  )
}

function Content({ children, className, ...props }: TileCompanionProps) {
  return (
    <div className={classNames(className, styles.contentContainer)} {...props}>
      {children}
    </div>
  )
}

Tile.Header = Header
Tile.Content = Content
export default Tile
